import { ChevronLeft, ChevronRight } from "lucide-react";

interface Props {
  currentMonth: number;
  currentYear: number;
  monthNames: string[];
  navigateMonth: (direction: string) => void;
  canNavigateToMonth:  (month: number, year: number) => boolean
}

export default function CalendarHeader({
  currentMonth,
  currentYear,
  monthNames,
  navigateMonth,
  canNavigateToMonth,
}: Props) {
  return (
    //DESKTOP
    <div className="flex items-center justify-between mb-6">
      <button
        onClick={() => navigateMonth("prev")}
        disabled={
          !canNavigateToMonth(
            currentMonth === 1 ? 12 : currentMonth - 1,
            currentMonth === 1 ? currentYear - 1 : currentYear
          )
        }
        className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center hover:bg-gray-300 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <ChevronLeft className="w-5 h-5 text-gray-600" />
      </button>

      <h3 className="text-xl font-semibold text-green-500">
        {monthNames[currentMonth - 1]}-{currentYear}
      </h3>

      <button
        onClick={() => navigateMonth("next")}
        disabled={
          !canNavigateToMonth(
            currentMonth === 12 ? 1 : currentMonth + 1,
            currentMonth === 12 ? currentYear + 1 : currentYear
          )
        }
        className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center hover:bg-gray-300 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <ChevronRight className="w-5 h-5 text-gray-600" />
      </button>
    </div>
  );
}
